import React from 'react';

const servicesData = [
  {
    icon: 'fas fa-satellite-dish',
    title: 'Antenas',
    description: 'Calibração, reparos de sinal e hardware.',
  },
  {
    icon: 'fas fa-desktop',
    title: 'Monitores',
    description: 'Reparo completo, troca de touch/LCD e eletrônica interna.',
  },
  {
    icon: 'fas fa-tint-slash',
    title: 'Remoção de Gel',
    description: 'Limpeza e restauração especializada de telas com gel.',
  },
  {
    icon: 'fas fa-tools',
    title: 'Troca de Carcaça',
    description: 'Restauração estética e proteção do seu equipamento.',
  },
  {
    icon: 'fas fa-power-off',
    title: 'Hardware',
    description: 'Solução para equipamentos que não ligam ou apresentam falhas.',
  },
  {
    icon: 'fas fa-sync',
    title: 'Atualização',
    description: 'Sistemas sempre em dia com as últimas versões dos fabricantes.',
  },
];

const Services = () => {
  return (
    <section id="servicos" style={{ background: 'var(--light)' }}>
      <div className="section-title">
        <h2>Reparos e Concertos</h2>
        <p>Manutenção especializada em todas as marcas e modelos</p>
      </div>

      <div className="services-grid">
        {servicesData.map((service, index) => (
          <div className="service-item" key={index}>
            <h3>
              <i className={service.icon}></i> {service.title}
            </h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
